import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const TemplateOutlet = lazy(() => import("@/pages/CustomTemplate/TemplateOulet"));
const CustomTemplateList = lazy(() => import("@/pages/CustomTemplate/SavedTemplatesGrid"));
const CustomTemplate = lazy(() => import("@/pages/CustomTemplate/CustomTemplate"));

const CustomTemplateRoute: RouteConfig = {
    path: "custom-template",
    pageName: "Custom Template",
    element: <TemplateOutlet />,
    sidebar: { show: true, icon: "" },
    children: {
        TEMPLATE_LIST: {
            path: "",
            element: <CustomTemplateList/>,
            pageName: "Custom Template",
        },
        TEMPLATE_EDITOR : {
            path: "editor",
            element: <CustomTemplate />,
            pageName: "Custom Template",
        }
    }
}

export default CustomTemplateRoute;